import React from 'react'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'
import styled from 'styled-components'
// @ts-ignore
import { ref } from '@netbasequid/theme'
// @ts-ignore
import { NoMarginCircle } from '@netbasequid/core'
import { useTranslation } from 'react-i18next'
import DashSymbol from './DashSymbol'

const StyledCellContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const StatusCircle = ({ isEnabled }: { isEnabled?: boolean }) => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  return (
    <StyledCellContainer>
      <NoMarginCircle
        fontSize={12}
        color={
          isEnabled
            ? ref.color.green[theme === 'light' ? 800 : 600]
            : ref.color.gray[theme === 'light' ? 600 : 1000]
        }
      />
      {/* eslint-disable-next-line no-nested-ternary */}
      {isEnabled === undefined ? <DashSymbol /> : isEnabled ? t('enabled') : t('disabled')}
    </StyledCellContainer>
  )
}

export default StatusCircle
